import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const customHtml: ComponentTemplate = {
  id: "0b45fbfc-ebe1-48ac-9028-267d2328ef9d",
  storeId: null,
  scope: "left-bar",
  type: "component",

  name: "Custom Code/Custom Code",
  leftBarCategory: { main: "customCode" },
  tags: ["html"],
  preview: "common/custom-code.svg",
  template: {
    id: "b8515872-925c-486a-a87b-db82408b0d37",
    type: "rawHtmlContent",
    props: {
      _htmlContent: "",
    },
  },
};
